import {
  app,
  Component,
  ojs,
  each,
  state,
  v,
  component,
} from "modular-openscriptjs";
import {
  pageInfo,
  scrollToTop,
} from "../../../helpers";
import { api, dc } from "../../../declarations";
import SearchResultProductView from "../../Views/SearchResultProductView";
import SolidIcon from "../../Blocks/SolidIcon";
import Spinner from "../../Blocks/Spinner";

const h = app("h");
const router = app("router");

ojs(SearchResultProductView, SolidIcon, Spinner);

export default class BrowseCategoryPage extends Component {
  products = state([]);
  subcategory = state(null);
  loading = state(true);
  businessId = null;
  subcategoryId = null;

  render(...args) {
    this.businessId = router.params.companyId;
    this.subcategoryId = router.params.subcategoryId;
    
    pageInfo("Browse Products");
    scrollToTop();

    if (this.loading.value && this.products.value.length === 0) {
        this.fetchProducts();
    }

    return h.div(
      { class: "py-4 mx-auto w-100 container mb-5 py-md-5" },
      
      h.div(
          { class: "mb-4 d-flex align-items-center gap-3" },
          h.button(
              { class: "btn btn-white border shadow-sm rounded-circle p-2", onclick: "history.back()" },
              h.SolidIcon("arrow-left")
          ),
          v(this.subcategory, (sub) => h.h2({ class: "fw-bold mb-0" }, sub.value?.name || "Products"))
      ),

      v(this.loading, (l) => {
          if (l.value) return h.div({ class: "text-center py-5" }, h.Spinner());

          return v(this.products, (prods) => {
              if (prods.value.length === 0) {
                  return h.div({ class: "text-center py-5 text-muted" }, "No products found in this subcategory.");
              }

              return h.div(
                  { class: "row g-3" },
                  ...prods.value.map(product => h.div(
                      { class: "col-12 col-md-6" },
                      h.SearchResultProductView(product)
                  ))
              );
          });
      }),
      ...args
    );
  }

  async fetchProducts() {
      try {
          const res = await api.get(`companies/${this.businessId}/subcategories/${this.subcategoryId}/products`);
          if (res) {
              this.products.value = res.data.products.data || res.data.products;
              this.subcategory.value = res.data.subcategory;
              if (res.data.subcategory) {
                  pageInfo(`${res.data.subcategory.name} - Browse`);
              }
          }
      } catch (e) {
          console.error(e);
      } finally {
          this.loading.value = false;
      }
  }
}

ojs(BrowseCategoryPage);
